import {
  faBars,
  faBell,
  faComment,
  faCommentAlt,
  faLanguage,
  faQuestion,
  faRightFromBracket,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MutableRefObject } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logos/logo_iica_white.svg";
import { Button, ButtonGroup, Dropdown } from "react-bootstrap";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";


const LangDropdown: React.FC = () => {
  const {t} = useTranslation('translation',{keyPrefix: 'layout.header'})

  const lngs: any = {
    en: { nativeName: "English" },
    es: { nativeName: "Español" },
  };
  return (
    <Dropdown>
      <Dropdown.Toggle
        id="dropdown-langs"
        variant="none"
        className="nav-link nav-profile d-flex align-items-center me-3"
      >
        <FontAwesomeIcon icon={faLanguage} className="me-1" />
        <span className="d-none d-md-block ps-1">{t("idioma")}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {Object.keys(lngs).map((lng) => (
          <Dropdown.Item key={lng} onClick={() => i18n.changeLanguage(lng)}>
            {lngs[lng].nativeName}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const Header: React.FC<{ appContainer: MutableRefObject<any> }> = ({
  appContainer,
}) => {

  const toggleSidebar = () => {
    var containerDiv = appContainer.current;
    if (containerDiv.className == "toggle-sidebar") {
      containerDiv.className = "";
      return;
    }
    containerDiv.className = "toggle-sidebar";
    return;
  };

  return (
    <header id="header" className="header fixed-top d-flex align-items-center">
      <div className="d-flex align-items-center justify-content-between">
        <i
          className="toggle-sidebar-btn"
          onClick={() => {
            toggleSidebar();
          }}
        >
          <FontAwesomeIcon icon={faBars} />
        </i>
        <Link to="/" className="logo d-flex align-items-center ms-4">
          <img src={logo} alt="IICA" className="me-2"/>
           <span>
            Conecta
            </span>
        </Link>
      </div>

      <div style={{ display: "none" }} className="search-bar">
        <form
          className="search-form d-flex align-items-center"
          method="POST"
          action="#"
        >
          <input
            type="text"
            name="query"
            placeholder="Search"
            title="Enter search keyword"
          />
          <button type="submit" title="Search">
            <i>
              <FontAwesomeIcon icon={faSearch} />
            </i>
          </button>
        </form>
      </div>

      <nav className="header-nav ms-auto">
        <ul className="d-flex align-items-center">

          <li style={{ display: "none" }} className="nav-item dropdown">
            <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
              <i>
                <FontAwesomeIcon icon={faBell} />
              </i>
              <span className="badge bg-primary badge-number">4</span>
            </a>

            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
              <li className="dropdown-header">
                You have 4 new notifications
                <a href="#">
                  <span className="badge rounded-pill bg-primary p-2 ms-2">
                    View all
                  </span>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>

              <li className="notification-item">
                <i className="bi bi-exclamation-circle text-warning"></i>
                <div>
                  <h4>Lorem Ipsum</h4>
                  <p>Quae dolorem earum veritatis oditseno</p>
                  <p>30 min. ago</p>
                </div>
              </li>

              <li>
                <hr className="dropdown-divider" />
              </li>

              <li className="notification-item">
                <i className="bi bi-x-circle text-danger"></i>
                <div>
                  <h4>Atque rerum nesciunt</h4>
                  <p>Quae dolorem earum veritatis oditseno</p>
                  <p>1 hr. ago</p>
                </div>
              </li>

              <li>
                <hr className="dropdown-divider" />
              </li>

              <li className="notification-item">
                <i className="bi bi-check-circle text-success"></i>
                <div>
                  <h4>Sit rerum fuga</h4>
                  <p>Quae dolorem earum veritatis oditseno</p>
                  <p>2 hrs. ago</p>
                </div>
              </li>

              <li>
                <hr className="dropdown-divider" />
              </li>

              <li className="notification-item">
                <i className="bi bi-info-circle text-primary"></i>
                <div>
                  <h4>Dicta reprehenderit</h4>
                  <p>Quae dolorem earum veritatis oditseno</p>
                  <p>4 hrs. ago</p>
                </div>
              </li>

              <li>
                <hr className="dropdown-divider" />
              </li>
              <li className="dropdown-footer">
                <a href="#">Show all notifications</a>
              </li>
            </ul>
          </li>

          <li style={{ display: "none" }} className="nav-item dropdown">
            <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
              <i>
                <FontAwesomeIcon icon={faCommentAlt} />
              </i>
              <span className="badge bg-success badge-number">3</span>
            </a>

            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow messages">
              <li className="dropdown-header">
                You have 3 new messages
                <a href="#">
                  <span className="badge rounded-pill bg-primary p-2 ms-2">
                    View all
                  </span>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>

              <li className="message-item">
                <a href="#">
                  <img
                    src="assets/img/messages-1.jpg"
                    alt=""
                    className="rounded-circle"
                  />
                  <div>
                    <h4>Maria Hudson</h4>
                    <p>
                      Velit asperiores et ducimus soluta repudiandae labore
                      officia est ut...
                    </p>
                    <p>4 hrs. ago</p>
                  </div>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>

              <li className="message-item">
                <a href="#">
                  <img
                    src="assets/img/messages-2.jpg"
                    alt=""
                    className="rounded-circle"
                  />
                  <div>
                    <h4>Anna Nelson</h4>
                    <p>
                      Velit asperiores et ducimus soluta repudiandae labore
                      officia est ut...
                    </p>
                    <p>6 hrs. ago</p>
                  </div>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>

              <li className="message-item">
                <a href="#">
                  <img
                    src="assets/img/messages-3.jpg"
                    alt=""
                    className="rounded-circle"
                  />
                  <div>
                    <h4>David Muldon</h4>
                    <p>
                      Velit asperiores et ducimus soluta repudiandae labore
                      officia est ut...
                    </p>
                    <p>8 hrs. ago</p>
                  </div>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>

              <li className="dropdown-footer">
                <a href="#">Show all messages</a>
              </li>
            </ul>
          </li>

          <li className="nav-item dropdown pe-3" style={{ display: "none" }}>
            <a
              className="nav-link nav-profile d-flex align-items-center pe-0"
              href="#"
              data-bs-toggle="dropdown"
            >
              <span className="d-none d-md-block dropdown-toggle ps-2">
                Randall Vargas
              </span>
            </a>

            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
              <li className="dropdown-header">
                <h6>Randall Vargas</h6>
                <span>randall.vargas@iica.int</span>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>

              <li>
                <a
                  className="dropdown-item d-flex align-items-center"
                  href="pages-faq.html"
                >
                  <i>
                    <FontAwesomeIcon icon={faQuestion} />
                  </i>
                  <span>Need Help?</span>
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>

              <li>
                <a className="dropdown-item d-flex align-items-center" href="#">
                  <i>
                    <FontAwesomeIcon icon={faRightFromBracket} />
                  </i>
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>
            
          </li>
          <li className="nav-item ">
            <LangDropdown/>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
